import { ApolloLink } from '@apollo/client';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'operation' implicitly has an 'any' type... Remove this comment to see the full error message
function developmentLog(operation, result, ellapsed) {
  console.groupCollapsed(`%c🚀 GQL - ${operation.operationName} - ${ellapsed}ms`, 'color: #285f96');
  console.log('OPERATION', operation);
  console.log('RESULT', result);
  console.groupEnd();
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'operation' implicitly has an 'any' type... Remove this comment to see the full error message
function productionLog(operation) {
  console.debug('GQL query', {
    name: operation.operationName,
    variables: operation.variables,
  });
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'op' implicitly has an 'any' type.
function safe(op) {
  try {
    op();
  } catch (e) {
    console.warn(e);
    console.error('could not log operation');
  }
}

class LogQueryLink extends ApolloLink {
  request(operation: any, forward: any) {
    const startTime = new Date();

    // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '__DEV__'.
    if (!__DEV__ && !process.env.NODE_ENV === 'test') {
      safe(() => productionLog(operation));
    }

    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
    return forward(operation).map((result) => {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '__DEV__'.
      if (__DEV__) {
        // @ts-expect-error ts-migrate(2363) FIXME: The right-hand side of an arithmetic operation mus... Remove this comment to see the full error message
        safe(() => developmentLog(operation, result, new Date().getTime() - startTime));
      }

      return result;
    });
  }
}

export { LogQueryLink };
